import React, { useState } from 'react';
import { X, Database, Server, FileText } from 'lucide-react';
import DataSourceAgent from './DataSourceAgent';
interface DataSourceModalProps {
  onClose: () => void;
}
const DataSourceModal: React.FC<DataSourceModalProps> = ({
  onClose
}) => {
  const [sourceType, setSourceType] = useState<'knowledge-base' | 'api' | 'file-upload' | null>(null);
  return <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50" data-id="element-461">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col" data-id="element-462">
        <div className="flex justify-between items-center border-b border-gray-200 px-6 py-4" data-id="element-463">
          <h2 className="text-lg font-medium text-gray-900" data-id="element-464">
            Add New Data Source
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-465">
            <X className="w-5 h-5" data-id="element-466" />
          </button>
        </div>
        <div className="flex-1 overflow-auto p-6" data-id="element-467">
          {!sourceType ? <div className="space-y-6" data-id="element-468">
              <p className="text-gray-500" data-id="element-469">
                Select the type of data source you want to add to your
                professional growth system:
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-470">
                <button onClick={() => setSourceType('knowledge-base')} className="border border-gray-200 rounded-lg p-6 text-left hover:border-blue-500 hover:bg-blue-50 transition-colors" data-id="element-471">
                  <div className="flex flex-col items-center" data-id="element-472">
                    <Database className="w-10 h-10 text-blue-600 mb-4" data-id="element-473" />
                    <h3 className="font-medium text-gray-900" data-id="element-474">
                      Knowledge Base
                    </h3>
                    <p className="text-sm text-gray-500 mt-2" data-id="element-475">
                      Create a new knowledge base and seed it with data
                    </p>
                  </div>
                </button>
                <button onClick={() => setSourceType('api')} className="border border-gray-200 rounded-lg p-6 text-left hover:border-blue-500 hover:bg-blue-50 transition-colors" data-id="element-476">
                  <div className="flex flex-col items-center" data-id="element-477">
                    <Server className="w-10 h-10 text-blue-600 mb-4" data-id="element-478" />
                    <h3 className="font-medium text-gray-900" data-id="element-479">
                      API Connection
                    </h3>
                    <p className="text-sm text-gray-500 mt-2" data-id="element-480">
                      Connect to an external API data source
                    </p>
                  </div>
                </button>
                <button onClick={() => setSourceType('file-upload')} className="border border-gray-200 rounded-lg p-6 text-left hover:border-blue-500 hover:bg-blue-50 transition-colors" data-id="element-481">
                  <div className="flex flex-col items-center" data-id="element-482">
                    <FileText className="w-10 h-10 text-blue-600 mb-4" data-id="element-483" />
                    <h3 className="font-medium text-gray-900" data-id="element-484">File Upload</h3>
                    <p className="text-sm text-gray-500 mt-2" data-id="element-485">
                      Upload documents to create a new data source
                    </p>
                  </div>
                </button>
              </div>
            </div> : <DataSourceAgent sourceType={sourceType} onBack={() => setSourceType(null)} data-id="element-486" />}
        </div>
        {!sourceType && <div className="border-t border-gray-200 px-6 py-4 flex justify-end" data-id="element-487">
            <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-488">
              Cancel
            </button>
          </div>}
      </div>
    </div>;
};
export default DataSourceModal;